import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarm,
  CPSConfigAlarmElement,
  CPSConfigCard,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P0003600Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('fsSAlarme') === 1) {
    if (getValue('fsSEtatProtectionMagnetique') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.FILTRATION_STANDARD,
        functionalityTitle: 'dashboard.filtration',
        title: 'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique',
        ctaTitle:
          'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique.reset',
        ctaFn: (editValue: any) => {
          editValue(
            P00039DataRxTxIndex.FiltrationStandard_Controle,
            'fsCResetManuelProtectionMagnetique',
            1,
          );
        },
      });
    }

    if (getValue('fsSEtatProtectionThermique') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.FILTRATION_STANDARD,
        functionalityTitle: 'dashboard.filtration',
        title: 'P0003600.parameters.status.statut.etatDeLaProtectionThermique',
        ctaTitle:
          'P0003600.parameters.status.statut.etatDeLaProtectionThermique.reset',
        ctaFn: (editValue: any) => {
          editValue(
            P00039DataRxTxIndex.FiltrationStandard_Controle,
            'fsCResetManuelProtectionThermique',
            1,
          );
        },
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.FILTRATION_STANDARD,
        functionalityTitle: 'dashboard.filtration',
        title: 'P0003600.parameters.status.statut.presenceDuProduit',
      });
    }
  }

  return res;
}
